var render, staticRenderFns
import script from "./ThgImpactSelectorTrees.vue?vue&type=script&lang=ts&"
export * from "./ThgImpactSelectorTrees.vue?vue&type=script&lang=ts&"
import style0 from "./ThgImpactSelectorTrees.vue?vue&type=style&index=0&id=1f237e35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f237e35",
  null
  
)

export default component.exports